/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BuildTestWorkflowRequest,
  CallerRef,
  MapString,
  NodeViews,
  NodeViewsRequestTestWorkflowInputNodeTestWorkflowNode,
  OptionWrappedWorkflowRequestBuildTestWorkflowRequest,
  PaginatedResultWrappedWorkflowRequestBuildTestWorkflowRequest,
  WorkflowChiliError,
  WorkflowExecutionResult,
  WorkflowTemplateView,
  WrappedWorkflowRequestBuildTestWorkflowRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "orchestrator";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description validates shape and workflow requirements
   *
   * @tags Workflows
   * @name ValidateWorkflowRequest
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/validate
   * @secure
   */
  validateWorkflowRequest = (
    tenantId: string,
    workspaceId: string,
    data: BuildTestWorkflowRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | CallerRef
      | (
          | WorkflowChiliError
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapString;
              data?: any;
            }
        )
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for validateWorkflowRequest */
  validateWorkflowRequestPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/validate`);

  /**
   * @description returns workflow template
   *
   * @tags Workflows
   * @name TemplateForTestWorkflow
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/template
   * @secure
   */
  templateForTestWorkflow = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      WorkflowTemplateView,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/template`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for templateForTestWorkflow */
  templateForTestWorkflowPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/template`);

  /**
   * @description attempts to return workflow for given id
   *
   * @tags Workflows
   * @name GetWorkflowForTestWorkflow
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/workflow/{workflowId}
   * @secure
   */
  getWorkflowForTestWorkflow = (
    tenantId: string,
    workspaceId: string,
    workflowId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      OptionWrappedWorkflowRequestBuildTestWorkflowRequest,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkflowForTestWorkflow */
  getWorkflowForTestWorkflowPathGetter = (tenantId: string, workspaceId: string, workflowId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}`);

  /**
   * @description attempts to upsert workflow
   *
   * @tags Workflows
   * @name UpsertWorkflowForTestWorkflow
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/workflow/{workflowId}
   * @secure
   */
  upsertWorkflowForTestWorkflow = (
    tenantId: string,
    workspaceId: string,
    workflowId: string,
    data: BuildTestWorkflowRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedWorkflowRequestBuildTestWorkflowRequest,
      | CallerRef
      | (
          | WorkflowChiliError
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapString;
              data?: any;
            }
        )
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertWorkflowForTestWorkflow */
  upsertWorkflowForTestWorkflowPathGetter = (tenantId: string, workspaceId: string, workflowId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}`);

  /**
   * @description attempts to return workflow for given id
   *
   * @tags Workflows
   * @name DeleteWorkflowForTestWorkflow
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/workflow/{workflowId}
   * @secure
   */
  deleteWorkflowForTestWorkflow = (
    tenantId: string,
    workspaceId: string,
    workflowId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWorkflowForTestWorkflow */
  deleteWorkflowForTestWorkflowPathGetter = (tenantId: string, workspaceId: string, workflowId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}`);

  /**
   * @description attempts to build nodes and generate views
   *
   * @tags Workflows
   * @name GenerateNodesView
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/node-views
   * @secure
   */
  generateNodesView = (
    tenantId: string,
    workspaceId: string,
    data: NodeViewsRequestTestWorkflowInputNodeTestWorkflowNode,
    params: RequestParams = {},
  ) =>
    this.request<
      NodeViews,
      | CallerRef
      | (
          | WorkflowChiliError
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapString;
              data?: any;
            }
        )
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/node-views`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for generateNodesView */
  generateNodesViewPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/node-views`);

  /**
   * @description attempts to list workflows
   *
   * @tags Workflows
   * @name ListWorkflowsForTestWorkflow
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/workflow
   * @secure
   */
  listWorkflowsForTestWorkflow = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultWrappedWorkflowRequestBuildTestWorkflowRequest,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listWorkflowsForTestWorkflow */
  listWorkflowsForTestWorkflowPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow`, query);

  /**
   * @description attempts manual execution of the workflow
   *
   * @tags Workflow Execution
   * @name ManuallyExecuteTestWorkflow
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/test-workflow/workflow/{workflowId}/manually-execute/{workflowNodeId}
   * @secure
   */
  manuallyExecuteTestWorkflow = (
    tenantId: string,
    workspaceId: string,
    workflowId: string,
    workflowNodeId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkflowExecutionResult,
      | CallerRef
      | (
          | WorkflowChiliError
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapString;
              data?: any;
            }
        )
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}/manually-execute/${workflowNodeId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for manuallyExecuteTestWorkflow */
  manuallyExecuteTestWorkflowPathGetter = (
    tenantId: string,
    workspaceId: string,
    workflowId: string,
    workflowNodeId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/test-workflow/workflow/${workflowId}/manually-execute/${workflowNodeId}`,
    );
}
